/* RAUL NERET — interactions: day/night toggle, nav, reveals, parallax, count-up */
(function () {
  const root = document.body;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(pointer: fine)').matches;

  /* ---- Day / Night (lights) ------------------------------------------- */
  const KEY = 'rn-lights';
  const lights = document.getElementById('lights');
  const apply = (mode) => {
    root.classList.toggle('day', mode === 'day');
    if (lights) lights.setAttribute('aria-pressed', String(mode === 'day'));
  };
  // default = night (lights off) — the glow is the whole point
  apply(localStorage.getItem(KEY) || 'night');
  if (lights) {
    lights.addEventListener('click', () => {
      const next = root.classList.contains('day') ? 'night' : 'day';
      apply(next);
      try { localStorage.setItem(KEY, next); } catch (e) {}
    });
  }

  /* ---- Sticky nav ----------------------------------------------------- */
  const nav = document.querySelector('.nav');
  const onScroll = () => nav && nav.classList.toggle('is-stuck', window.scrollY > 40);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---- Mobile menu ---------------------------------------------------- */
  const burger = document.querySelector('.burger');
  const menu = document.querySelector('.mobile-menu');
  if (burger && menu) {
    burger.addEventListener('click', () => {
      const open = menu.classList.toggle('open');
      nav.classList.toggle('open', open);
      root.classList.toggle('menu-open', open);
      burger.setAttribute('aria-expanded', String(open));
    });
    menu.querySelectorAll('a').forEach((a) =>
      a.addEventListener('click', () => {
        menu.classList.remove('open');
        nav.classList.remove('open');
        root.classList.remove('menu-open');
      })
    );
  }

  /* ---- Reveal on scroll (staggered) ----------------------------------- */
  const items = document.querySelectorAll('.reveal, .reveal-up, .reveal-fade, .reveal-blur');
  if (reduce || !('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('in'));
  } else {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      }),
      { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }
    );
    items.forEach((el) => io.observe(el));
  }

  /* ---- Hero: 3D parallax tilt following the cursor -------------------- */
  const hero = document.querySelector('.hero');
  const heroVisual = document.querySelector('.hero__visual');
  if (hero && heroVisual && !reduce && fine) {
    let raf = 0, tx = 0, ty = 0;
    const render = () => {
      raf = 0;
      heroVisual.style.transform =
        'rotateY(' + (tx * 7).toFixed(2) + 'deg) rotateX(' + (-ty * 7).toFixed(2) +
        'deg) translate3d(' + (tx * 12).toFixed(1) + 'px,' + (ty * 12).toFixed(1) + 'px,0)';
    };
    hero.addEventListener('pointermove', (e) => {
      const r = hero.getBoundingClientRect();
      tx = (e.clientX - r.left) / r.width - 0.5;
      ty = (e.clientY - r.top) / r.height - 0.5;
      if (!raf) raf = requestAnimationFrame(render);
    });
    hero.addEventListener('pointerleave', () => { tx = 0; ty = 0; if (!raf) raf = requestAnimationFrame(render); });
  }

  /* ---- Count-up for stats -------------------------------------------- */
  const nums = document.querySelectorAll('[data-count]');
  const parseNum = (raw) => raw && raw.match(/^(\D*)([\d.,]+)(.*)$/);
  nums.forEach((el) => {
    const m = parseNum(el.getAttribute('data-count'));
    if (!m) return;
    const prefix = m[1], hasComma = m[2].indexOf(',') > -1, suffix = m[3];
    const target = parseFloat(m[2].replace(/,/g, ''));
    const fmt = (n) => { n = Math.round(n); return hasComma ? n.toLocaleString('en-US') : String(n); };
    if (reduce) { return; }
    el.textContent = prefix + fmt(0) + suffix;
    const run = () => {
      const dur = 1500, t0 = performance.now();
      const tick = (now) => {
        const p = Math.min((now - t0) / dur, 1);
        const eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + fmt(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(tick);
        else el.textContent = el.getAttribute('data-count');
      };
      requestAnimationFrame(tick);
    };
    if ('IntersectionObserver' in window) {
      const io2 = new IntersectionObserver((entries) => entries.forEach((e) => {
        if (e.isIntersecting) { run(); io2.unobserve(e.target); }
      }), { threshold: 0.6 });
      io2.observe(el);
    } else { run(); }
  });

  /* ---- Magnetic primary buttons -------------------------------------- */
  if (!reduce && fine) {
    document.querySelectorAll('.btn--solid:not(.reveal-up)').forEach((el) => {
      const s = 0.28, max = 14;
      const clamp = (v) => Math.max(-max, Math.min(max, v));
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        const x = clamp((e.clientX - r.left - r.width / 2) * s);
        const y = clamp((e.clientY - r.top - r.height / 2) * s);
        el.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
      });
      el.addEventListener('pointerleave', () => { el.style.transform = ''; });
    });
  }

  /* ---- Product size selector ----------------------------------------- */
  const sizes = document.querySelector('.sizes');
  if (sizes) {
    const vidInput = document.getElementById('variant-id');
    const priceEl = document.getElementById('product-price');
    const addBtn = document.getElementById('add-btn');
    const reqBtn = document.getElementById('request-btn');
    const note = document.getElementById('sizes-note');
    const piece = sizes.getAttribute('data-piece') || '';
    const opts = sizes.querySelectorAll('.size-opt');
    const pick = (btn) => {
      opts.forEach((o) => { o.classList.remove('is-active'); o.setAttribute('aria-checked', 'false'); });
      btn.classList.add('is-active'); btn.setAttribute('aria-checked', 'true');
      if (vidInput) vidInput.value = btn.getAttribute('data-vid');
      const avail = btn.getAttribute('data-available') === 'true';
      const price = btn.getAttribute('data-price');
      if (priceEl) priceEl.textContent = price ? price : 'Price on request';
      if (note) note.hidden = avail;
      if (addBtn) addBtn.hidden = !avail;
      if (reqBtn) {
        reqBtn.hidden = avail;
        if (!avail) {
          reqBtn.setAttribute('href', '/pages/contact?piece=' +
            encodeURIComponent(piece) + '&size=' + encodeURIComponent(btn.getAttribute('data-size')));
        }
      }
    };
    opts.forEach((o) => o.addEventListener('click', () => pick(o)));
  }

  /* ---- Contact form prefill (from a "request this size" link) --------- */
  const cmsg = document.getElementById('cmsg');
  if (cmsg && window.location.search) {
    const q = new URLSearchParams(window.location.search);
    const piece = q.get('piece'), size = q.get('size');
    if ((piece || size) && !cmsg.value) {
      const lines = [];
      if (piece) lines.push('Piece: ' + piece);
      if (size) lines.push('Size: ' + size + '  (special — made to order)');
      lines.push('', 'Hi Raul, I would like to request this piece in the size above. ' +
        'Could you confirm availability, price and shipping? Thank you!');
      cmsg.value = lines.join('\n');
      const topic = document.getElementById('ctopic');
      if (topic) { for (let k = 0; k < topic.options.length; k++) { if (/buy/i.test(topic.options[k].text)) { topic.selectedIndex = k; break; } } }
    }
  }

  /* ---- Gallery filters ------------------------------------------------ */
  const fbtns = document.querySelectorAll('.filter-btn');
  if (fbtns.length) {
    const pieces = document.querySelectorAll('.pieces [data-category]');
    fbtns.forEach((b) =>
      b.addEventListener('click', () => {
        fbtns.forEach((x) => x.classList.remove('is-active'));
        b.classList.add('is-active');
        const f = b.dataset.filter;
        pieces.forEach((p) => { p.hidden = !(f === 'all' || p.dataset.category === f); });
      })
    );
  }

  /* ---- Tiny cart counter (prototype) ---------------------------------- */
  window.rnAddToCart = function (btn) {
    document.querySelectorAll('.cart-n').forEach((el) => {
      el.textContent = String((parseInt(el.textContent, 10) || 0) + 1);
    });
    if (btn) {
      if (!btn.dataset.orig) btn.dataset.orig = btn.textContent;
      btn.textContent = 'Added to cart ✓';
      setTimeout(() => { btn.textContent = btn.dataset.orig; }, 1600);
    }
  };
})();

/* ---- Search overlay -------------------------------------------------- */
/* NOTA: numele openSearch/closeSearch sunt intentionate — `open`/`close`
   se ciocnesc cu window.open/window.close dupa minificarea facuta de Shopify. */
(function () {
  var openBtn = document.getElementById('searchOpen');
  var overlay = document.getElementById('searchOverlay');
  var closeBtn = document.getElementById('searchClose');
  var input = document.getElementById('searchInput');
  if (!openBtn || !overlay) return;

  var lastFocus = null;

  function openSearch() {
    lastFocus = document.activeElement;
    overlay.removeAttribute('hidden');
    /* reflow fortat: face tranzitia sa porneasca fara sa depindem de
       requestAnimationFrame (care nu ruleaza cand tabul nu compoziteaza) */
    void overlay.offsetWidth;
    overlay.classList.add('open');
    document.body.classList.add('search-open');
    if (input) { input.focus(); input.select(); }
  }

  function closeSearch() {
    overlay.classList.remove('open');
    document.body.classList.remove('search-open');
    window.setTimeout(function () {
      if (!overlay.classList.contains('open')) overlay.setAttribute('hidden', '');
    }, 330);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  openBtn.addEventListener('click', function (e) {
    e.preventDefault();
    openSearch();
  });
  if (closeBtn) closeBtn.addEventListener('click', function (e) {
    e.preventDefault();
    closeSearch();
  });

  /* click pe fundal (in afara continutului) inchide */
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeSearch();
  });

  document.addEventListener('keydown', function (e) {
    var isOpen = overlay.classList.contains('open');
    if (e.key === 'Escape' && isOpen) { closeSearch(); return; }
    /* "/" deschide cautarea, daca nu scrii deja intr-un camp */
    if (e.key === '/' && !isOpen) {
      var t = e.target;
      var typing = t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable);
      if (!typing) { e.preventDefault(); openSearch(); }
    }
  });

  /* nu trimite formularul gol */
  var form = overlay.querySelector('.search-ov__form');
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!input || !input.value.trim()) { e.preventDefault(); if (input) input.focus(); }
    });
  }
})();
